var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productImageThumbnail"},[_c('AdvancedImage',{attrs:{"lazy":true,"src":_vm.image.src,"alt":_vm.image.alt,"config":_vm.config,"modifier":"centered"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }